import { useSearchParams } from 'react-router-dom';
import { BarChartIcon, CertificateIcon, DashboardIcon, DownloadIcon, FilterIcon } from '../components/icons';
import PageHeader from '../components/common/PageHeader';
import ComplianceDashboard from '../components/reporting/ComplianceDashboard';
import ActionQueue from '../components/reporting/ActionQueue';
import ActivityReport from '../components/reporting/ActivityReport';
import CertificatesReport from '../components/reporting/CertificatesReport';
import { Box, Tab, Tabs } from '../components/ui';

const TAB_KEYS = ['activity', 'dashboard', 'action-queue', 'certificates'] as const;
type TabKey = typeof TAB_KEYS[number];

function tabKeyFromIndex(i: number): TabKey {
  return TAB_KEYS[i] ?? TAB_KEYS[0];
}

function indexFromTabKey(key: string | null): number {
  const idx = TAB_KEYS.indexOf((key ?? TAB_KEYS[0]) as TabKey);
  return idx >= 0 ? idx : 0;
}

export default function ReportsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = indexFromTabKey(searchParams.get('tab'));

  const setActiveTab = (i: number) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', tabKeyFromIndex(i));
    setSearchParams(next, { replace: true });
  };

  return (
    <Box sx={{ p: 4 }}>
      <PageHeader icon={<BarChartIcon />} title="Reports" />

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)}>
          <Tab label="Activity Report" icon={<DownloadIcon />} iconPosition="start" />
          <Tab label="Compliance Dashboard" icon={<DashboardIcon />} iconPosition="start" />
          <Tab label="Action Queue" icon={<FilterIcon />} iconPosition="start" />
          <Tab label="Certificates" icon={<CertificateIcon />} iconPosition="start" />
        </Tabs>
      </Box>

      {activeTab === 0 && <ActivityReport />}
      {activeTab === 1 && <ComplianceDashboard />}
      {activeTab === 2 && <ActionQueue />}
      {activeTab === 3 && <CertificatesReport />}
    </Box>
  );
}
